// extracted by mini-css-extract-plugin
module.exports = {"btn":"partFitForVehicleInput_btn__dZpHR","h3":"partFitForVehicleInput_h3__vU867","item":"partFitForVehicleInput_item__b3ToL","h":"partFitForVehicleInput_h__EuLQD"};